import { FC, useState } from "react";
import { floatToPriceWithoutSpace } from "../../functions/price_functions";
import "./resumeCart.css";
import { BsChevronUp, BsChevronDown } from "react-icons/bs";
import { useDiscount } from "../../hooks/useDiscount";
import useCart from "../../contexts/cartContext/cartContext";


const ResumeCart: FC = () => {
    const [isOpen, setIsOpen] = useState(true);
    const { subtotalWithDiscount, subtotal } = useCart()
    const { getDiscountValue, hasDiscount } = useDiscount();
    const cashbackValue = hasDiscount("cashback") ? getDiscountValue("cashback") : 0;
    const totalDiscount = subtotal - subtotalWithDiscount;
    const otherDiscount = Math.max(0, Number((totalDiscount - cashbackValue).toFixed(2)));

    return (
        <div className="resumeCart">
            <div className="main">
                <h4>Resumo da Compra</h4>
                {isOpen ? (
                    <BsChevronDown onClick={() => setIsOpen(false)} />
                ) : (
                    <BsChevronUp onClick={() => setIsOpen(true)} />
                )}
            </div>
            {isOpen && (
                <>
                    <div className="item-resume">
                        <p>Valor dos Produtos</p>
                        <p className="price">{floatToPriceWithoutSpace(subtotal)}</p>
                    </div>
                    <div className="item-resume">
                        <p>Desconto</p>
                        <p className="price-discount">
                            {floatToPriceWithoutSpace(otherDiscount)}
                        </p>
                    </div>
                    {cashbackValue > 0 && (
                        <div className="item-resume">
                            <p>Cashback</p>
                            <p className="price-discount">
                                {floatToPriceWithoutSpace(cashbackValue)}
                            </p>
                        </div>
                    )}
                    <div className="item-total-resume">
                        <p>Total da compra</p>
                        <p className="price">
                            {floatToPriceWithoutSpace(subtotalWithDiscount)}
                        </p>
                    </div>
                </>
            )}
        </div>
    );
};

export { ResumeCart };
